import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { MatCardModule} from '@angular/material/card';
import { MatButtonModule} from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSelectModule } from '@angular/material/select';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule} from '@angular/material/icon';
import { MatStepperModule} from '@angular/material/stepper';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule} from '@angular/material/radio';
import { MatSliderModule} from '@angular/material/slider';
import { MatCheckboxModule} from '@angular/material/checkbox';
import { MatDialogModule} from '@angular/material/dialog';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { StepperComponent } from './stepper/stepper.component';
import { NavBarComponent} from './nav-bar/nav-bar.component';
import { LayoutModule} from '@angular/cdk/layout';
import { HomeComponent } from './home/home.component';
import { TranslateLoader, TranslateModule} from '@ngx-translate/core';
import { TranslateHttpLoader} from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule, HttpHeaders} from '@angular/common/http';
import { Step1LitrageComponent } from './steps/step1-litrage/step1-litrage.component';
import { ModelsDataProvider} from './data/ModelsDataProvider';
import { StepButtonsComponent } from './steps/step-buttons/step-buttons.component';
import { Step2ModelComponent } from './steps/step2-model/step2-model.component';
import { SimulationSessionProvider} from './data/SimulationSessionProvider';
import { Step3PriceComponent } from './steps/step3-price/step3-price.component';
import { Step4InstallationComponent } from './steps/step4-installation/step4-installation.component';
import { NumbersOverviewComponent } from './numbers-overview/numbers-overview.component';
import { ResultsOverviewComponent } from './results-overview/results-overview.component';
import { AristoDialogComponent } from './aristo-dialog/aristo-dialog.component';
import { NewSessionDialogComponent } from './new-session-dialog/new-session-dialog.component';
import { EmailDialogComponent } from './email-dialog/email-dialog.component';
import { ConnectionServiceModule} from 'ng-connection-service';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    StepperComponent,
    NavBarComponent,
    HomeComponent,
    Step1LitrageComponent,
    StepButtonsComponent,
    Step2ModelComponent,
    Step3PriceComponent,
    Step4InstallationComponent,
    NumbersOverviewComponent,
    ResultsOverviewComponent,
    AristoDialogComponent,
    NewSessionDialogComponent,
    EmailDialogComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
      defaultLanguage: 'fr',
    }),
    AppRoutingModule,
    BrowserAnimationsModule,
    MatCardModule,
    MatButtonModule,
    MatToolbarModule,
    MatSelectModule,
    MatMenuModule,
    MatIconModule,
    LayoutModule,
    MatStepperModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatSliderModule,
    MatCheckboxModule,
    MatDialogModule,
    HttpClientModule,
    ConnectionServiceModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
  ],
  providers: [
    ModelsDataProvider,
    SimulationSessionProvider
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
